import { Button, notification } from 'antd';
import { ReactNode } from 'react';
import { track } from '../../tracking';

export const openNotification = (options: {
    key: string;
    message: ReactNode;
    duration: number;
    notificationType?: 'info' | 'error' | 'success' | 'warning' | 'open';
    description?: string;
    ctas?: { btns: ReactNode };
    onClose?: () => void;
    onClick?: () => void;
    className?: string;
}): void => {
    const {
        duration,
        key,
        message,
        ctas,
        description,
        onClose,
        notificationType = 'open',
        onClick,
        className,
    } = options;

    track('NOTIFICATION', { type: notificationType, message: message?.toString() });

    notification[notificationType]({
        message,
        description,
        btn: ctas?.btns,
        key,
        onClose,
        duration: duration ?? 2,
        onClick,
        className,
    });
};
